import React from "react";

function Avatar({ src, name = "", online = false, size = 40 }) {

  const bgColors = ["#007bff", "#6610f2", "#6f42c1", "#e83e8c", "#fd7e14", "#20c997"];
  const bgColor = bgColors[name.length % bgColors.length];

  const initials = name ? name.split(" ").map(n => n[0]).join("").slice(0, 2).toUpperCase() : "?";

 return (
  <div
    className="avatar-wrapper"
    style={{
      width: size,
      height: size,
      position: "relative",
      flexShrink: 0,
    }}
  >
    {src ? (
      <img
        src={src}
        alt={name}
        className="avatar-img"
      />
    ) : (
      <div
        className="avatar-fallback"
        style={{
          backgroundColor: bgColor,
        }}
      >
        {initials}
      </div>
    )}

    {online && (
      <span className="online-indicator"></span>
    )}
  </div>
);
}

export default Avatar